export function isTruthyValue(value){return!!value}